<template>
<div class="inkdet">
	<div class=inkdettop>
		<div class="inkdetleft" @click="click_left">
		&lt;&lt;&lt;
		</div>
		<div class=inkdettext>
			fabricante: <b>{{ manufacturer }}</b>
			<span v-if="has_series">
			&nbsp;&nbsp;&nbsp;
			série: <b>{{ series }}</b>
			</span>
			&nbsp;&nbsp;&nbsp;
			nome: <b>{{ name }}</b>
			&nbsp;&nbsp;&nbsp;
			grupo de cor: <b>{{ color }}</b>
			<br>
			<br>
			<div v-if="! editing">
			{{ description }}
			<br>
			<br>
			<a v-if="editable" href="" @click="edit">editar</a>
			<a v-if="! editable && ! revealed" href="" @click="reveal">atualização pendente</a>
			</div>

			<div v-if="revealed">
			<i>{{ new_description }}</i>
			<br>
			<br>
			<a href="" @click="commit">confirmar alteração</a>
			</div>

			<div v-if="editing">
			<textarea v-model.trim="descinput" rows="7" cols="50" autofocus>{{ description }}</textarea>
			<br>
			<a href="" @click="submit">enviar</a>
			&nbsp;
			&nbsp;
			&nbsp;
			<a href="" @click="cancel">cancelar</a>
			</div>
		</div>
		<div class="inkdetright" @click="click_right">
		&gt;&gt;&gt;
		</div>
	</div>
	<img :src="file">
</div>
</template>

<script>

import axios from 'axios';

function get_info(o)
{
	if (o.$route.params.ident === o.info_ident) {
		return true;
	}

	if (! o.$store.state.loaded) {
		return false;
	}

	o.info_ident = o.$route.params.ident;
	o.info = o.$store.getters.ink(o.$route.params.ident);
	if (Array.isArray(o.info.color)) {
		o.info_color = o.$store.getters.color(o.info.color[0]);
	} else {
		o.info_color = o.$store.getters.color(o.info.color);
	}
	return true;
}

export default {
	name: 'InkDetails',
	data: () => {
		return {
			editing: false,
			revealed: false,
			descinput: "",
		};
	},
	mounted: () => {
		window.scrollTo(0, 0);
	},
	computed: {
		manufacturer() {
			if (! get_info(this)) {
				return "";
			}

			return this.info.manufacturer;
		},
		name() {
			if (! get_info(this)) {
				return "";
			}

			return this.info.name;
		},
		has_series() {
			if (! get_info(this)) {
				return false;
			}

			return !!this.info.series;
		},
		series() {
			if (! get_info(this)) {
				return "";
			}

			return this.info.series;
		},
		color() {
			if (! get_info(this)) {
				return "";
			}

			return this.info_color.name;
		},
		description() {
			if (! get_info(this)) {
				return "";
			}

			return this.info.description;
		},
		new_description() {
			if (! get_info(this)) {
				return "";
			}

			return this.info.new_description;
		},
		editable() {
			if (! get_info(this)) {
				return false;
			}

			return !this.info.new_description;
		},
		file() {
			if (! get_info(this)) {
				return "";
			}

			return "/swablib/inks/" + this.info.ident + ".jpg";
		},
	},
	methods: {
		click_left() {
			let path = "/ink/" + this.$store.getters.next_ink(this.info.ident, -1);
			console.log("Opening " + path);
			this.$router.replace({ path: path });
		},
		click_right() {
			let path = "/ink/" + this.$store.getters.next_ink(this.info.ident, +1);
			console.log("Opening " + path);
			this.$router.replace({ path: path });
		},
		edit(e) {
			e.preventDefault();
			this.descinput = this.info.description;
			this.editing = true;
		},
		reveal(e) {
			e.preventDefault();
			this.revealed = true;
		},
		commit(e) {
			e.preventDefault();
			this.revealed = false;
			let password = prompt("Digite a senha de confirmação");
			if (! password) {
				return;
			}
			this.$store.dispatch('commit_description',
				{"ink": this.info.ident,
				"password": password});
		},
		submit(e) {
			e.preventDefault();
			this.editing = false;
			if (this.descinput) {
				this.$store.dispatch('update_description',
					{"ink": this.info.ident,
					"description": this.descinput});
			}
		},
		cancel(e) {
			e.preventDefault();
			this.editing = false;
		},
	},
}
</script>

<style scoped>

div.inkdet {
}

div.inkdettop {
	display: flex;
	flex-direction: row;
}

div.inkdettext {
	width: 70%;
}

div.inkdetleft {
	width: 15%;
	user-select: none;
}

div.inkdetright {
	width: 15%;
	user-select: none;
}

div.inkdet img {
	margin-top: 1em;
	width: 100%;
	margin-top: 1em ! important;
	margin-bottom: 0 ! important;
	margin-right: 0 ! important;
	margin-left: 0 ! important;
	border: none ! important;
	padding: 0 ! important;
}

div.inkdet a {
	font-style: normal;
	text-decoration: none;
	color: #00f;
}

</style>



// WEBPACK FOOTER //
// src/components/InkDetails.vue